export class SetRedirectPath {
  public static readonly type = '[Redirect] SetRedirectPath';
  constructor(public readonly redirectPath: string) {}
}
